import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda06 = () => {
  const handleDownload = () => {

    const link = document.createElement('a');
    link.href = '/app/assets/pdf/SCHEDA-6_Tabelle.pdf'; 
    link.download = 'SCHEDA-6_Tabelle.pdf';
    link.click();
  };

  return (<>
    <PageHeader
    title="Scheda 06"
    description="SCHEMA SELEZIONE AZIENDALE AMBITI DI INTERVENTO PRINCIPALI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>La proposta base è inizialmente limitata a 33 Ambiti, con un abbinamento univoco tra codici CSVC e codici d’IMPATTO/ FINANZIARI, raggruppati secondo le dimensioni della Sostenibilità (Ambiente AMB, Governance GOV, e Sociale SOC) e associati alle tipologie degli ambiti A, B e C. In questo modo si consente alla azienda di effettuare una prima selezione degli ambiti principali in modo semplice e integrato, che potrà essere affinato dopo le valutazioni di cui alla TERZA FASE. </p>
            <br />    
            <button onClick={handleDownload}>Apri tabella allegata</button>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda06;
